export default [
  {
    label: 'Archive matter',
    target: '/case-management/matters/matter-archive',
    appendClientMatterNoToTarget: true,
    requiredMenuItemId: 1213
  },
  {
    label: 'Restore matter',
    postLoadAction: 'restoreMatter',
    postLoadSelector: '#ctl00_MainContentPlaceHolder_ArchRestBtn',
    target: '/case-management/matters/matter-page?viewextensions=true',
    appendClientMatterNoToTarget: true,
    requiredMenuItemId: 1213
  },
  {
    label: 'Edit matter',
    target: `/case-management/matters/matter-detail/edit-matter`,
    appendClientMatterNoToTarget: true,
    requiredMenuItemId: 1211
  },
  {
    label: 'Post time for this matter',
    requiredMenuItemId: 2110,
    target: 'OPEN TIME DRAWER'
  },
  {
    label: 'Create new',
    children: [
      {
        label: 'Document',
        target: `/case-management/matters/document-production`,
        appendClientMatterNoToTarget: true,
        requiresCurrentMatter: true,
        menuItemId: 3400,
        requiredMenuItemId: 3400
      },
      {
        label: 'Email',
        target: `/case-management/matters/matter-page?viewextensions=true`,
        appendClientMatterNoToTarget: true,
        postLoadAction: 'sendEmail',
        requiresCurrentMatter: true,
        menuItemId: 1200,
        requiredMenuItemId: 1200
      },
      {
        label: 'SMS',
        target: `/case-management/matters/matter-page?viewextensions=true`,
        appendClientMatterNoToTarget: true,
        postLoadAction: 'sendSms',
        requiresCurrentMatter: true,
        menuItemId: 1200,
        requiredMenuItemId: 1200
      },
      {
        label: 'Key date',
        target: 'NEWKEYDATE',
        requiresCurrentMatter: true,
        menuItemId: 3100,
        requiredMenuItemId: 3100
      },
      {
        label: 'Requisition',
        target: `/accounts/client-ledger/requisition`,
        appendClientMatterNoToTarget: true,
        requiresCurrentMatter: true,
        menuItemId: 5300,
        requiredMenuItemId: 5300
      }
    ]
  },
  {
    label: 'Client workspace',
    target: `/case-management/clients/client-workspace`,
    appendClientMatterNoToTarget: true,
    menuItemId: 1100,
    requiredMenuItemId: 1100
  },
  {
    label: 'Matter workspace',
    target: `/case-management/matters/matter-workspace`,
    appendClientMatterNoToTarget: true,
    menuItemId: 1200,
    requiredMenuItemId: 1200
  }
]
